import * as React from 'react';
import toast from 'cogo-toast';
import { Page, Grid, Form, Button } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';

class Subscribe extends PageComponent {
  state = {
    isProcessing: false,
    promotion: true,
    upgrade: true,
  };

  async componentDidMount() {
    const data = await Request.post('emailSubscribe');
    const { promotion = true, upgrade = true } = data || {};
    this.setState({ promotion, upgrade });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isProcessing: true });
    const data = await Request.post('emailSubscribe', {
      subscribed: {
        promotion: this.state.promotion,
        upgrade: this.state.upgrade,
      },
    });
    if (data) {
      toast.success(' 邮件订阅更新成功');
    }
    this.setState({ isProcessing: false });
  };

  render() {
    return (
      <Grid.Row className="malus-setting">
        <Grid.Col xl={6} offsetXl={3} lg={6} offsetLg={3}>
          <Page.Card title="邮件订阅">
            <Form onSubmit={this.handleSubmit}>
              <Form.InputGroup>
                <Form.Checkbox
                  checked={this.state.promotion}
                  label="活动促销信息"
                  name="promotion"
                  onChange={() => {
                    this.setState(prevState => ({
                      promotion: !prevState.promotion,
                    }));
                  }}
                />
              </Form.InputGroup>
              <Form.InputGroup>
                <Form.Checkbox
                  checked={this.state.upgrade}
                  label="产品更新"
                  onChange={() => {
                    this.setState(prevState => ({
                      upgrade: !prevState.upgrade,
                    }));
                  }}
                  name="upgrade"
                />
              </Form.InputGroup>
              <Button
                className="malus-setting-btn"
                disabled={this.state.isProcessing}
                loading={this.state.isProcessing}
                type="submit"
                color="primary"
                value="Submit">
                确认
              </Button>
            </Form>
          </Page.Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default Subscribe;
